"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSpaEntryfileUrl = createSpaEntryfileUrl;
function getEnvironmentPostfix(environment) {
  switch (environment) {
    case 'stg':
    case 'uat':
    case 'dev':
      return `.${environment}`;
    default:
      return '';
  }
}

/**
 * Builds URL pointing to the entry file of the specified SPA
 * @param spaName Name (codename) of the SPA
 * @param environment Code of environment for which should the SPA be loaded
 * @param baseUrl Base url of the blob storage with SPAs
 * @returns Complete url of the SPA entry file
 */
function createSpaEntryfileUrl(spaName, environment, baseUrl) {
  const urlPrefix = baseUrl && !baseUrl.endsWith('/') ? `${baseUrl}/` : baseUrl ?? '';
  return `${urlPrefix}${spaName}/index${getEnvironmentPostfix(environment)}.js`;
}
